/* * @Author: slimcheng * @Date: 2018-01-25 10:54:27 * @Last Modified by:
slimcheng * @Last Modified time: 2018-01-25 14:52:28 */

<template>
<div>
  <!--<canvas style="border: 1px solid gray;display:none;" width="500px" height="500px" ref="qr"></canvas>-->
  <img :src="imgsrc">
  </div>
</template>

<script>
import QRious from "qrious";
export default {
  name: "QRCode",
  props: {
    config: {
      type: Object,
      default: function() {
        return {value: 'https://github.com/neocotic/qrious'};
      },
      set(newValue) {
        this.qr.set({value: newValue});
        console.log('Neuer QR-Wert: ' + newValue);
        this.imgsrc = this.qr.toDataURL();
      }
    },
  },
  data() {
    return {
      qr: new QRious( this.getQrConfig() ),
      imgsrc: '',
    };
  },
  methods: {
      getQrConfig() {
          return Object.assign(
          {
            level: 'Q',//L,M,Q,H
            mime: 'image/png',
            padding: 25,
            size: 300,
            value: 'https://github.com/neocotic/qrious',
            background: '#edf0f5',
            backgroundAlpha: 1,
            foreground: '#111',
            foregroundAlpha: 0.8,
          },
          this.config)
      }
  },
  mounted() {
    console.log("QR Code generated");
    this.imgsrc = this.qr.toDataURL();
  },
  watch: {
    config: {
      handler: function(/*newValue, oldValue*/) {
        console.log("QR Code handler");
        this.qr.set( this.getQrConfig() );
        this.imgsrc = this.qr.toDataURL();
      },
      deep: true,
    },
  },
};
</script>
